import AuthService from "../services/auth.service";
import { mapGetters } from 'vuex';

const token = localStorage.getItem("token");

const initialState = token
  ? {
    status: { loggedIn: true },
    user: null, // we’ll refresh this from API
    isProfileComplete: false,
    access_token: token,
    isProfileSubscriptionExpired: false,
    NoOFDaysFreeUsage: false,
  }
  : {
    status: { loggedIn: false },
    user: null,
    isProfileComplete: false,
    access_token: "",
    isProfileSubscriptionExpired: false,
    NoOFDaysFreeUsage: false,
  };


export const auth = {
  namespaced: true,
  state: initialState,
  getters: {
    getLoggedIn: (state) => state.status.loggedIn,
    getUserData: (state) => state.user,
    getAccessToken: (state) => state.access_token,
    getProfileCompleteStatus: (state) =>
      state.user?.company_name &&
      state.user.company_name !== "N/A" &&
      state.user?.companytype &&
      state.user.companytype !== "N/A",
    getUserSubscriptionExpire: (state) => {
      const remaining = state.user?.subscription_details?.noOfDaysRemaining;
      return remaining === 'expired' || parseInt(remaining) <= 0;
    },
    getUserNoOFDays: (state) => {
      const freeDays = state.user?.noOfDaysOfFreeUsage !== undefined ? state.user?.noOfDaysOfFreeUsage : state.user?.no_of_days_of_free_usage;
      return parseInt(freeDays) <= 0;
    },
  },
  computed: {
    ...mapGetters("auth", ["getUserData"]),
    user() {
      return this.getUserData; // Reactively bind to user data
    },
  },
  actions: {
    login({ commit }, user) {
      return AuthService.login(user).then(
        (user) => {
          commit("loginSuccess", user);
          return Promise.resolve(user);
        },
        (error) => {
          // Don't clear storage here: a failed attempt (e.g. 429) must not
          // log out other tabs through the storage event.
          commit("loginFailure");
          return Promise.reject(error);
        }
      );
    },
    storeTokenToState({ commit }, token) {
      commit("saveToken", token);
    },
    logout({ commit }) {
      AuthService.logout();
      commit("logout");
    },
    register({ commit }, user) {
      return AuthService.register(user).then(
        (response) => {
          commit("registerSuccess");
          return Promise.resolve(response.data);
        },
        (error) => {
          commit("registerFailure");
          return Promise.reject(error);
        }
      );
    },
    forgotPassword(context, user) {
      return AuthService.forgotPassword(user).then((response) => response.data);
    },
    changePassword({ commit }, data) {
      return AuthService.changePassword(data).then(
        (response) => {
          return Promise.resolve(response.data);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
    updateCurrency({ commit, dispatch }, currency) {
      return AuthService.updateCurrency(currency).then(
        (response) => {
          if (response.data && response.data.status == 1) {
            dispatch("refreshProfile");
          }
          return Promise.resolve(response.data);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
    updateLanguage({ commit, dispatch }, language) {
      return AuthService.updateLanguage(language).then(
        (response) => {
          if (response.data && response.data.status == 1) {
            dispatch("refreshProfile");
          }
          return Promise.resolve(response.data);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
    updateCountry({ commit, dispatch }, country) {
      return AuthService.updateCountry(country).then(
        (response) => {
          if (response.data && response.data.status == 1) {
            dispatch("refreshProfile");
          }
          return Promise.resolve(response.data);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
    refreshProfile({ commit }) {
      return AuthService.getProfile().then(
        (response) => {
          // console.log("Profile API response:", response.data);
          commit("refreshUserData", response.data);
          return Promise.resolve(response.data);
        },
        (error) => {
          console.error("Error refreshing profile:", error);
          return Promise.reject(error);
        }
      );
    },
  },
  mutations: {
    saveToken(state, token) {
      state.access_token = token;
      localStorage.setItem("token", token);
    },
    // Token already in localStorage (page load or another tab logged in /
    // refreshed); only sync state.
    sessionRestored(state, token) {
      state.access_token = token;
      state.status.loggedIn = true;
    },
    loginSuccess(state, user) {
      state.status.loggedIn = true;
      state.user = user.response;
    },
    refreshUserData(state, userData) {
      state.user = userData.response;// Adjust based on actual API response structure
    },
    loginFailure(state) {
      state.status.loggedIn = false;
      state.user = null;
    },
    logout(state) {
      state.status.loggedIn = false;
      state.user = null;
      state.access_token = "";
    },
    registerSuccess(state) {
      state.status.loggedIn = false;
      ``;
    },
    setCompanyDetails(state, { companyname, business_category_id }) {
      if (state.user) {
        state.user = {
          ...state.user,
          company_name: companyname,
          companytype: business_category_id,
        }; // Ensure reactivity
      }
    },
    clearLogoUrl(state) {
      if (state.user) {
        state.user = {
          ...state.user,
          logourl: "N/A",
        };
      }
    },
    updateUserSettings(state, updates) {
      if (state.user) {
        state.user = {
          ...state.user,
          ...updates
        };
      }
    },
    registerFailure(state) {
      state.status.loggedIn = false;
    },
  },
};
